/* this file added by Bearer Web Developer  */
import React, { useRef } from 'react';
import { TextFieldProps } from '@mui/material';
import styles from './BearerOptionsField.module.scss'; // added by Bearer Web Developer
type IColorStyle = "blue" | "gray" | "white";
type BearerTextFieldProps = TextFieldProps & { validator?: (value: string) => string | undefined }
    & { colorStyle?: IColorStyle } // extended by Bearer Web Developer
    & { withoutLabel?: boolean } // extended by Bearer Web Developer
    & { options: { label: string, value: string }[] };
// selectProperties interface added by Bearer Web Developer
interface selectProperties {
    label?: string
    value?: string
    onChange?: () => {}
    onClick?: () => {}
    disabled?: boolean
    placeholder?: string
    name?: string
}

const BearerOptionsField: React.FC<BearerTextFieldProps> = ({ validator, options, withoutLabel, colorStyle, ...props }) => {
    const [touched, setTouched] = React.useState(false);
    const [error, setError] = React.useState({ value: null as null | string, error: false, helperText: '' }); // value: '' changed to value: null as null for not showing empty value errors by Bearer Web Developer
    const selectRef = useRef(null);
    React.useEffect(() => {

        if (validator) { // validator && props.value changed to validator for not showing empty value errors by Bearer Web Developer
            const value = props?.value as string;
            if (error.value !== value) {
                const helperText = validator(value);
                if (helperText) {
                    setError({ value, error: true, helperText });
                } else {
                    if (error.error) {
                        setError({ value, error: false, helperText: '' });
                    }
                }
            }
        }
    }, [validator, props.value, touched, error, setError])

    const handleFocus = () => {
        setTouched(true);
    }
    // modified by Bearer Web Developer start
    const { label, name, placeholder, ...otherProps } = props as selectProperties;
    return (
        <div className={otherProps.disabled ? `${styles.disabled} ${styles.text_select}` : styles.text_select}>
            <div className={`${colorStyle ? styles?.[colorStyle] : styles.blue}`}>
                {
                    !withoutLabel &&
                    <div className={styles.label}>
                        <label htmlFor={name || label?.toString()}>{label}</label>
                    </div>
                }
                <div className={`${styles.select_part}`}>
                    <select name={name || label?.toString()} id={name || label?.toString()} ref={selectRef}
                        onFocus={handleFocus} placeholder={placeholder} {...otherProps as selectProperties}  >
                        <option value="">...</option>
                        {options?.map((op, i) => (<option key={i} value={op?.value}>{op?.label}</option>))}
                    </select>
                    <img className={styles.expand_more} src={`/expand_more_black.png`} alt=""
                        onClick={() => { if (selectRef) (selectRef?.current as any)?.showPicker(); }}
                    />
                </div>
                {error.error &&
                    <div className={styles.error}>
                        <img src="/error-red.png" alt="" />
                        <div className={!colorStyle || (colorStyle && colorStyle === "blue") ? styles.error_blue : ''}>
                            {error.helperText}
                        </div>
                    </div>}
            </div>
        </div>
    );
    // modified by Bearer Web Developer end
}
export default BearerOptionsField;